<div class="sidebar-container">

  <div class="header-container">
    <img src="assets/images/logo.png" width="220px" style="max-height: 56px;" />
  </div>

  <div class="image-container" *ngIf="sharedService.userSession && sharedService.userSession.id" >
    <div class="image-profile">
      <img style="width: 50px; height: 50px; border-radius: 25px;" src="assets/images/profile.jpg">
    </div>

    <div class="user-title" [matMenuTriggerFor]="menu">
      <span>{{sharedService.userSession.nombres}}</span><br>
      <span>{{sharedService.userSession.apellidoPaterno}}</span>
    </div>
  </div>

  <mat-nav-list>
    <div *ngFor="let item of navItems">
      <app-menu-list-item *ngIf="!item.hide" [item]="item"></app-menu-list-item>
    </div>
  </mat-nav-list>

  <div *ngIf="sharedService.planSession" class="footer-container">
    <button mat-button (click)="abrirSidebarObjetivos()" style="color: #191a1f; padding-left: 8px; font-size: 16px; width: calc(100% - 25px); float: left;">
      Buscador Global
    </button>
    <mat-icon *ngIf="!sharedService.abrirSidebarObjetivos" style="color: #191a1f; float: right;">keyboard_arrow_right</mat-icon>
    <mat-icon *ngIf="sharedService.abrirSidebarObjetivos" style="color: #191a1f; float: right;">keyboard_arrow_left</mat-icon>
  </div>
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="abrirMisDatos()">
    <mat-icon>account_circle</mat-icon> Perfil
  </button>
  <button mat-menu-item (click)="abrirCambiarClave()">
    <mat-icon>vpn_key</mat-icon>Cambiar contraseña
  </button>
  <button mat-menu-item (click)="authService.logOut()">
    <mat-icon>input</mat-icon>Cerrar Sesión
  </button>
</mat-menu>
